import styles from "../../Style/List.module.css";
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Stack } from "@fluentui/react/lib/Stack";
import { useBoolean } from "@fluentui/react-hooks";
import { useTranslation } from "react-i18next";
import { WorkSpace } from "../../../model/WorkSpaceModel";
import TextFieldComp from "../../../components/TextField/TextFieldComp";
import WorkSpaceAdmListComp from "./WorkSpaceAdmListComp";
import { useProfile } from "../../../context/ProfileProvider/useProfile";



const WorkSpaceAdmList  = (props: any) => {
  const [itens, setWork] = useState<WorkSpace[]>(new Array<WorkSpace>());
  const navegate = useNavigate();
  const [isOpen, { setTrue: openPanel, setFalse: dismissPanel }] =
    useBoolean(false);
  const [newOrgName, setNewOrgName] = useState<string>();
  const forceUpdate = useCallback((teste: string) => setNewOrgName(teste), []);
  const { t, i18n } = useTranslation();
  const [initialsChanged, setInitials] = useState<string>("");
  const [internalNameChanged, setInternalNameChanged] = useState<string>("");

  const [userEdit, setUserEdit] = useState<string|undefined|number>(0)
  const [userDeleted, setUserDeleted] = useState<string|undefined>(undefined);

  const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);
  const [userDeletedName, setUserDeletedName] = useState<string>("");

  const [isChecked, setChecked] = useState<boolean>(false);
  const [popupOk, setPopupOk] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  
  const [reload, setReload] = useState<boolean>(false);
  const [searchName, setSearchName] = useState<string>("");

  const profile = useProfile();
  const [isAdminOrganization, setisAdminOrganization] = useState<boolean>(false);

  const { nameOrg } = useParams();

  useEffect(() => {
    if(typeof userEdit != "number")
    {
      openPanel();
    }
  }, [userEdit]);

  useEffect(() => {
    if(userDeleted != undefined)
    {
      toggleHideDialog();
    }
  }, [userDeleted]);


  useEffect(() => {
    if(reload == true ){
      setReload(false)
    }
  }, [reload]);

  useEffect(() => {
    if(profile.organizations != undefined)
    {
      for(let organization of profile.organizations)
      {
        if(nameOrg == organization.internalName)
        {
          if(organization.isAdmin == true)
          {
            
            setisAdminOrganization(true);
          }
          else{
            setisAdminOrganization(false);
          }
        }
      }
    }
  }, [profile]);

  const iconProps = { iconName: "Filter" };

  const onChangeSearchName =
  (event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
    if (newValue != undefined ) {
      setSearchName(newValue);
    }
  };


  return (
    <div>
      <Stack horizontal className={styles.hPage}>   
        <Stack.Item grow>
          <h3 className={styles.hList}>Workspaces</h3>
        </Stack.Item>     
        <Stack.Item className={styles.InputSearch}>
            <TextFieldComp iconProps={iconProps}  value={searchName} onChange={onChangeSearchName} />
          </Stack.Item>
      </Stack>
      
      {reload?(<div></div>):(
          nameOrg != undefined?(
            <WorkSpaceAdmListComp
              nameOrg={nameOrg}
              name={searchName}
              hiddenContexMenu={isAdminOrganization == false}
            />
          ):(<li className={styles.itemContent}></li>))}
    </div>
  );
};


export default WorkSpaceAdmList;
